/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Bars3Icon } from "@heroicons/react/24/outline";

/**
 * DraggableListMC component renders a list of draggable items using react-beautiful-dnd.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.items - The list of items to be rendered and made draggable.
 * @param {Function} props.onDragEnd - Callback function to handle the end of a drag event.
 * @param {React.Component} props.ItemComponent - The component used to render each item.
 * @param {string} [props.className=''] - Additional class names to apply to the container.
 *
 * @returns {JSX.Element} The rendered draggable list component.
 */
const DraggableListMC = ({
  items,
  onDragEnd,
  ItemComponent,
  className = ''
}) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="droppable">
      {(provided) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          className={`tw-w-full ${className}`}
        >
          {items.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(providedItem) => (
                <div
                  ref={providedItem.innerRef}
                  {...providedItem.draggableProps}
                  {...providedItem.dragHandleProps}
                  className="tw-flex tw-items-center tw-mb-2"
                >
                  <Bars3Icon className="tw-h-6 tw-w-6 tw-text-gray-500 tw-mx-2" />
                  <ItemComponent data={item} />
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

export default DraggableListMC;
